var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-9"
  }, [_c('h5', {
    staticClass: "mb-2 mb-md-1"
  }, [_vm._v(" " + _vm._s(_vm.domain.Name) + " "), _vm.domain.Description ? _c('i', {
    staticClass: "fas fa-info-circle text-muted",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "data-html": "true",
      "data-title": _vm.domain.Description,
      "original-title": _vm.domain.Description
    }
  }) : _vm._e(), _vm.clickable ? _c('i', {
    staticClass: "text-info fas fa-chevron-circle-right"
  }) : _vm._e()]), _c('p', {
    staticClass: "text-muted m-0",
    domProps: {
      "innerHTML": _vm._s(_vm.domain.Question)
    }
  }), _c('p', {
    staticClass: "text-muted m-1",
    staticStyle: {
      "font-size": "14px",
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.domain.Note))])]), _c('div', {
    staticClass: "col-md-4 col-lg-3 mt-4 mt-md-0"
  }, [_c('div', {
    staticClass: "rounded py-2 px-3 text-center",
    class: `bg-${_vm.designation.bgColor} text-${_vm.designation.textColor}`
  }, [_c('span', {
    staticClass: "font-weight-bold h5 mb-0"
  }, [_vm._v(_vm._s(_vm.designation.label) + " "), _vm.ineligibilityReason ? _c('small', {
    staticClass: "d-block"
  }, [_vm._v(_vm._s(_vm.ineligibilityReason.Description))]) : _vm._e()])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };